import React from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { useSelector } from "react-redux";


function InfiniteScrollWrapper({
  isInfiniteScrollOn,
  lengthData,
  functionNext,hasMore,
  children
}) {
  const {frontLabelsName } = useSelector(
    (state) => state.language
  );
  if (!isInfiniteScrollOn) return <>{children}</>;


  return (
    <div   style={{ marginTop: "50px" }}   >
      <InfiniteScroll
        dataLength={lengthData} //This is important field to render the next data 
        next={functionNext}
        hasMore={hasMore}
        loader={<h4>Loading...</h4>}
          scrollableTarget="scrollableDiv"
        endMessage={
          <p style={{ textAlign: "center" }}>
            <b>{frontLabelsName
                              ? frontLabelsName.filter((e) => e.key == "lbl_you_have_seen_it_all")
                                  .length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_you_have_seen_it_all"
                                  )[0]["value"] || "lbl_you_have_seen_it_all"
                                : "lbl_you_have_seen_it_all"
                              : "lbl_you_have_seen_it_all"}</b>
          </p>
        }
        className="new-infinte-scroll"
      >
        {children} {/** !!! DO NOT TOUCH !!! => It wraps the table */}
      </InfiniteScroll>
    </div>
  );
}

export default InfiniteScrollWrapper;